import React from 'react';
import PropTypes from 'prop-types';

const ProgressBar = ({ value, maxValue, showWarning }) => {
    const progress = (value * 100) / maxValue;
    const style= {
        width: `${progress}%`
    };
    const progressBackgroundColor = showWarning ? 'background-critical' : 'background-success';
    return(
         <div className="progress">
            <div 
                className={`progress-bar text-progress-success ${progressBackgroundColor}`} 
                role="progressbar" 
                aria-valuenow={progress} 
                aria-valuemin="0" 
                aria-valuemax="100" 
                style={style}>
                <span className="text-progress">{progress.toFixed(0)}%</span>
            </div>
        </div>
    );
};

ProgressBar.propTypes = {
    value: PropTypes.number.isRequired,
    maxValue: PropTypes.number.isRequired,
    showWarning: PropTypes.bool
};

export default ProgressBar;


// WEBPACK FOOTER //
// ./src/common/progress/ProgressBar.js